// 1. Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav).
// Specifically, the target element is the one we would like to allow scroll on (NOT a parent of that element).
// This is also the element to apply the CSS '-webkit-overflow-scrolling: touch;' if desired.
const targetElement = document.querySelector('.popup_text_box');

// Get the modal
var modal = document.getElementById("preOrderModal");

var modalCont = document.getElementsByClassName("modal-content")[0];

// Get the button that opens the modal
var btn = document.getElementById("openPreorderModal");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close-button")[0];

var termsSpan = document.getElementsByClassName("metafield-multi_line_text_field")[0];

var popupBtn = document.getElementsByClassName('js-popup-cart-button')[0]

async function addToCart() {
  const selectedVariant = document.querySelector('[name="id"]');
  const quantityInput = document.getElementsByClassName('quantity__input')[0]
  console.log(quantityInput.value)
  let formData = {
    items: [
      {
        quantity: quantityInput.value,
        id: selectedVariant.value
      }
    ]
  }
  console.log(formData);
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      console.log(response.json())
      window.location.href = "/cart"
      // return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}


const getSelectedVariant = () => {
  const selectedVariant = document.querySelector('[name="id"]');
  const modalVariants = document.getElementsByClassName('variant-blocks');
  for (let i = 0; i < modalVariants.length; i++) {
    if (modalVariants[i].id !== `forVariant${selectedVariant.value}`) {
      modalVariants[i].style.display = 'none'
    } else {
      modalVariants[i].style.display = 'block'
    }
  }
}

window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload();
  }
};

// When the user clicks on the button, open the modal
if(btn) {
  btn.onclick = function () {
    getSelectedVariant();
    if (this.classList.contains('product-form__submit--disabled')) return;
    modal.style.display = "flex";
    bodyScrollLock.disableBodyScroll(targetElement, termsSpan);

    // When the modal is shown, we want a fixed body
    // "bodyScrollLock.disableBodyScroll" is Countermeasure to prevent body from scrolling in iOS safari
  }
}

popupBtn.onclick = function (e) {
  e.preventDefault()
  addToCart();
}

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  modal.style.display = "none";
  // When the modal is hidden, we want to remain at the top of the scroll position
  bodyScrollLock.clearAllBodyScrollLocks();
  // clear bodyScrollLock
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
    bodyScrollLock.clearAllBodyScrollLocks();
    // clear bodyScrollLock
  }
}
